import { Base } from './types';

// The marketing site lives on its own host now that the app moved to
// app.harness.co — window.location.origin would point these links (terms,
// privacy, disclosures, articles…) back into the app, and the old staging
// host no longer resolves.
const MARKETING_SITE_URL = 'https://www.harness.co';

const baseConfig: Base = {
  MARKETING_SITE_URL,
  ALLOWED_REDIRECT_DOMAINS: ['harnesswealth.com', 'harness.co'],
  URL_TERMS_OF_SERVICE: `${MARKETING_SITE_URL}/terms-of-service/`,
  URL_PRIVACY_POLICY: `${MARKETING_SITE_URL}/privacy-policy/`,
  URL_IN_THE_NEWS: `${MARKETING_SITE_URL}/in-the-news/`,
  URL_HARNESS_FOR_EMPLOYERS: `${MARKETING_SITE_URL}/harness-for-employers/`,
  URL_CRS_FORM: `${MARKETING_SITE_URL}/form-crs-client-relationship-summary/`,
  URL_CRS_DISCLOSURES: `${MARKETING_SITE_URL}/client-relationship-disclosures/`,
  URL_DISCLOSURES: `${MARKETING_SITE_URL}/disclosures/`,
  URL_PROMOTERS_DISCLOSURE: `${MARKETING_SITE_URL}/promoters-disclosure/`,
  URL_ADV_PART_2A: 'https://adviserinfo.sec.gov/firm/brochure/299795',
  URL_CRS: `${MARKETING_SITE_URL}/form-crs-client-relationship-summary/`,
  URL_ABOUT_US: `${MARKETING_SITE_URL}/about-us/`,
  URL_ARTICLES: `${MARKETING_SITE_URL}/articles/`,
  URL_LINKEDIN: 'https://linkedin.com/company/harnesswealth',
  URL_TWITTER: 'https://twitter.com/HarnessWealth',
  URL_INSTAGRAM: 'https://www.instagram.com/harnesswealth',
  URL_ROADMAP: 'https://harness.canny.io/',
  URL_GLB_PRIVACY_NOTICE: `${MARKETING_SITE_URL}/gramm-leach-bliley-privacy-notice/`,
  GOOGLE_SSO_CLIENT_ID: '750398498729-llhcm9553633mjinq8okjcrm9ci2kd3b.apps.googleusercontent.com',
  URL_ADVISOR_AGREEMENT: `${MARKETING_SITE_URL}/advisor-agreement/`,
};

export default baseConfig;
